import React from 'react'
import { useReplace } from 'infrastructure/routing'
import { useCurrentUserRedirectResource } from './auth.hooks'

export default function Auth() {
  const userData = useCurrentUserRedirectResource()
  const replace = useReplace()
  if (userData.state === 'loading') {
    return null
  }
  if (userData.redirectUrl) {
    replace(userData.redirectUrl)
    return null
  }
  return <></>
}
